import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {oeInterfaceManager} from '../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../react-oe/oe-interface-adapter';
import {OEHideFlags} from '../../react-oe/oe-types';
import OEColorHelper from '../../lib/color/oe-color-helper';
import OEStyleSheetTool from '../../lib/tools/oe-style-sheet-tool';
import OEIconCodes from '../../lib/oe-icon-codes';
import OEToolbox from '../../lib/tools/oe-toolbox';
import retardUpdate from '../../lib/react/update-retarder';
import {OEModal} from './oe-modal';
import OEColor from '../color-picker/oe-color';
import OEIcon from '../elements/oe-icon';
import OECoreHideLayer from '../views/oe-core-hide-layer';
import {OEBlurModalBackdropLayer} from '../views/oe-blur-layer';

export default class OEStdModalController extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.isOpen_ = false;
        this.options = this.props.options;

        this.state = {
            isOpen:             this.isOpen_,
            options:            clone(this.options),
            strings: {
                title:          'EFFIGOS EXPLORER',
            },
            backgroundColor:    OEColorHelper.stdBackgroundColor(OEStyleSheetTool.brightness),
            textColor:          OEColorHelper.stdLabelTextColor(OEStyleSheetTool.brightness)
        };

        this.onColorModelChanged = this.onColorModelChanged.bind(this);

        this.updateLanguage = this.updateLanguage.bind(this);
        this.onBgColorChanged = this.onBgColorChanged.bind(this);

        this.renderHeader = this.renderHeader.bind(this);

        this.onToggle = this.onToggle.bind(this);
    }

    setOpen(open = true, options)   {
        let optionsChanged = false;

        if((open || typeof(this.props.isOpen) === 'boolean') && !this.props.options && !OEToolbox.shallowEqual(this.options, options, true))    {
            this.options = clone(options);
            this.setState({options: clone(this.options)});
            optionsChanged = true;
            if(typeof(this.props.isOpen) === 'boolean') {
                if(this.props.onOptionsChanged) this.props.onOptionsChanged(this, this.options);
                return;
            }
        }

        if(typeof(this.props.isOpen) === 'boolean') {
            if(optionsChanged && this.props.onOptionsChanged)  this.props.onOptionsChanged(this, this.options);
            return;
        }

        let isOpenChanged = this.isOpen_ != open;

        this.isOpen_ = open;
        this.setState({isOpen: this.isOpen_});

        if(isOpenChanged && this.props.onOpenStateChanged)  this.props.onOpenStateChanged(this, this.isOpen_);
        if(optionsChanged && this.props.onOptionsChanged)  this.props.onOptionsChanged(this, this.options);
    }

    open(options) {
        this.setOpen(true, options);
    }

    close() {
        this.setOpen(false);
    }

    isOpen()    {
        return this.isOpen_;
    }

    toggle()    {
        this.setOpen(!this.isOpen());
    }

    componentDidMount()    {
        this.onColorModelChanged();
        OEColorHelper.registerModelChangeListener(this.onColorModelChanged);
    }

    componentWillUnmount()    {
        OEColorHelper.unregisterModelChangeListener(this.onColorModelChanged);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.options !== this.props.options)    {
            this.options = nextProps.options;
            this.setState({options: clone(this.options)});
            if(this.props.onOptionsChanged) this.props.onOptionsChanged(this, this.options);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.bgColorChanged, this.onBgColorChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.bgColorChanged, this.onBgColorChanged);
    }

    onColorModelChanged()   {
        if(!this.oe.isReady())  {
            this.setState({
                backgroundColor: OEColorHelper.stdBackgroundColor(OEStyleSheetTool.brightness),
                textColor: OEColorHelper.stdLabelTextColor(OEStyleSheetTool.brightness)
            });
            return;
        }
        this.onBgColorChanged();
    }

    updateLanguage()   {
        let headerStringId = this.props.headerStringId;
        let preHeader = this.oe.sharedInterface.getLocalizedStringEnc(headerStringId + '_pre_header');
        let header = this.oe.sharedInterface.getLocalizedStringEnc(headerStringId + '_header');

        this.setState({ strings: {
            title: {header: header, preHeader: preHeader}
        }});
    }

    onBgColorChanged(message, userInfo)  {
        let brightness = typeof(userInfo) === 'undefined' ? this.oe.sharedInterface.getUIControllerColorTheme().getBackgroundColorBrightness() : userInfo.brightness;
        this.setState({
            backgroundColor: OEColorHelper.stdBackgroundColor(brightness),
            textColor: OEColorHelper.stdLabelTextColor(brightness)
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        retardUpdate(this, () => {
            this.updateLanguage();
            this.onBgColorChanged();
        });
    }

    renderHeader(props)  {
        if(this.props.renderHeader) return this.props.renderHeader(props);
        
        let title = props.title;
        let header = null;

        if(typeof(title) === 'string')  {

            if(title != '') header = <h5 className="modal-title">{title}</h5>;

        } else if(typeof(title) === 'object')   {
            if(title.text || title.icon)    {

                header = (<h5 className="modal-title icon-text">{title.icon ? <OEIcon code={title.icon}/> : null}<span className="text">{title.text}</span></h5>);

            } else if(typeof(title.header) === 'string')    {

                if(typeof(title.preHeader) === 'string' && title.preHeader !== '#null') {
                    header = (<h5 className="modal-title">{title.preHeader}<br/>{title.header}</h5>);
                } else {
                    header = (<h5 className="modal-title">{title.header}</h5>);
                }
            }
        }

        return (
            <div className={'header ' + (!props.logo ? 'no-logo ' : '') + props.headerClassName}>
                {props.logo ? <img className="logo" src = {props.logo}/> : null}
                {header}
                {this.props.additionalButtons ? this.props.additionalButtons(props) : null}
                {props.hasCloseBtn ? <button type="button" className="close-btn" onClick={props.onToggle}> <OEIcon code={OEIconCodes.close} /> </button> : null}
            </div>
        );
    }

    render() {
        const {children, ...rest} = this.props;
        let isOpen = typeof(this.props.isOpen) === 'boolean' ? this.props.isOpen : this.state.isOpen;
        let title = this.props.title || this.props.title === '' ? this.props.title : this.state.strings.title;

        let modalContentStyle = {
            backgroundColor:    OEColor.toDOMStr(this.state.backgroundColor),
            color:              OEColor.toDOMStr(this.state.textColor)
        };

        if(this.props.style)    modalContentStyle = Object.assign(modalContentStyle, this.props.style);

        let coreHideFlags = this.props.coreHideFlags;
        let blurBackground = this.props.blurBackground;
        let optionalClassName = '';

        if(typeof(this.state.options) === 'object') {
            if(typeof(this.state.options.className) === 'string')       optionalClassName = this.state.options.className;
            if(typeof(this.state.options.coreHideFlags) === 'number')   coreHideFlags = this.state.options.coreHideFlags;
            if(typeof(this.state.options.blurBackground) === 'boolean') blurBackground = this.state.options.blurBackground;
        }

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OEModal
                    {...rest}
                    className={'std-modal-controller ' + this.props.className + ' ' + optionalClassName}
                    style={modalContentStyle}
                    isOpen={isOpen}
                    keyboard={this.props.keyboard}
                    title={title}
                    onToggle={this.onToggle}
                    renderHeader={this.renderHeader}
                >
                    {this.props.children}

                    {blurBackground ? <OEBlurModalBackdropLayer/> : null}
                </OEModal>
                <OECoreHideLayer moduleId={this.props.moduleId} hideFlags={isOpen ? coreHideFlags : 0}/>
            </React.Fragment>
        );
    }

    onToggle(id, params) {
        if(this.props.onToggle)  {
            this.props.onToggle(id, params);
        } else {
            this.setOpen(false);
        }
    }
}

OEStdModalController.defaultProps = {
    moduleId:           '',
    rootClassName:      '',
    className:          '',
    zIndex:             1050,
    noHeader:           false,
    headerClassName:    '',
    headerStringId:     'start_view',
    hasCloseBtn:        true,
    keyboard:           true,
    backdrop:           true,
    toggleOnBackdrop:   false,
    coreHideFlags:      OEHideFlags.none,
    blurBackground:     false
};

OEStdModalController.propTypes = {
    moduleId:           PropTypes.string,
    rootClassName:      PropTypes.string,
    className:          PropTypes.string,
    style:              PropTypes.object,
    logo:               PropTypes.string,
    zIndex:             PropTypes.number,
    noHeader:           PropTypes.bool,
    headerClassName:    PropTypes.string,
    headerStringId:     PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
        text:           PropTypes.string,
        icon:           PropTypes.string
    })]),
    hasCloseBtn:        PropTypes.bool,
    isOpen:             PropTypes.bool,
    keyboard:           PropTypes.bool,
    options:            PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
        className:      PropTypes.string,
        coreHideFlags:  OECoreHideLayer.propTypes.hideFlags,
        blurBackground: PropTypes.bool,
    })]),
    onOpenStateChanged: PropTypes.func,
    onOptionsChanged:   PropTypes.func,
    onToggle:           PropTypes.func,
    renderHeader:       PropTypes.func,
    additionalButtons:  PropTypes.func,
    renderFooter:       PropTypes.func,
    buttons: PropTypes.arrayOf(PropTypes.shape({
        className:      PropTypes.string,
        title:          PropTypes.string,
        onClick:        PropTypes.func
    })),
    backdrop:           PropTypes.bool,
    toggleOnBackdrop:   PropTypes.bool,
    coreHideFlags:      OECoreHideLayer.propTypes.hideFlags,
    blurBackground:     PropTypes.bool,
    onEnter:            PropTypes.func,
    onExit:             PropTypes.func,
    onOpened:           PropTypes.func,
    onClosed:           PropTypes.func
};